/*
 * Visualiseur InstrumenPoche en Javascript et SVG
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const ActionAncetre = require('./actionAncetre')
module.exports = ActionMontrerNombres
// Cette action agit sur les graduations externes du rapporteur
/**
 * Action montrant changeant le statut des gradiations externes du rapporteur
 * @extends iep.actionAncetre
 * @constructor
 * @param {iep.iepDoc} doc : le document propriétaire
 * @param {boolean} bmontrer : true si on montre les graduations, false sinon
 * @param {type} tempo
 */
function ActionMontrerNombres (doc, bmontrer, tempo) {
  ActionAncetre.call(this, doc, tempo)
  this.bmontrer = bmontrer
}
ActionMontrerNombres.prototype = new ActionAncetre()
/**
 * Exécution de l'action changeant le statut des gradiations externes du rapporteur
 * @param {boolean} immediat : si true on ne passe pas à l'action suivante
 */
ActionMontrerNombres.prototype.execute = function (immediat) {
  this.doc.rapporteur.montreGraduationsExternes(this.bmontrer)
  if (!immediat) this.doc.actionSuivante(immediat)
}
/** @inheritDoc */
ActionMontrerNombres.prototype.actionVisible = function () {
  return this.doc.getInstrumentVisibility(this.doc.rapporteur, this.indice - 1)
}
